import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "table-courier-comission" }
const _hoisted_2 = { class: "flex w-full items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "text-sm text-white font-bold" }, "Simpan", -1)
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "flex items-center mb-6 gap-4" }
const _hoisted_6 = { class: "flex w-full content-start overflow-x-scroll container-kategori-scroll gap-2" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = {
  key: 0,
  class: "flex gap-2 items-center"
}
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey" }, [
  /*#__PURE__*/_createTextVNode("Komisi/Kg/"),
  /*#__PURE__*/_createVNode("strong", null, "Resi")
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("p", { class: "color-blue-grey" }, [
  /*#__PURE__*/_createTextVNode("Komisi/"),
  /*#__PURE__*/_createVNode("strong", null, "Kg")
], -1)
const _hoisted_11 = {
  key: 0,
  class: "p-field mb-4"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("label", {
  for: "integeronly",
  class: "text-body2"
}, "Bonus", -1)
const _hoisted_13 = { class: "relative mt-1 flex w-1/2 items-center" }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "absolute right-1 text-right" }, "/resi", -1)
const _hoisted_15 = { class: "con-header-table" }
const _hoisted_16 = { class: "flex w-full section-header items-center justify-between" }
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "font-bold" }, "Besaran Komisi", -1)
const _hoisted_18 = { class: "flex text-sm" }
const _hoisted_19 = /*#__PURE__*/_createVNode("p", { class: "font-medium color-blue-grey" }, "*komisi dihitung berdasarkan ", -1)
const _hoisted_20 = {
  key: 0,
  class: "font-bold text-black"
}
const _hoisted_21 = {
  key: 1,
  class: "font-bold text-black"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("div", {
  id: "spreadsheet",
  class: "excel-clone w-full"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode("h6", null, _toDisplayString(_ctx.Posisition === 1 ? 'Pengaturan Besaran Komisi' : 'Pengaturan Besaran Prediksi Komisi'), 1),
          (_ctx.route.meta.permission.update)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                class: "btn-primary p-button-sm rounded-md",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.submitDataExcel()))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      content: _withCtx(() => [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              (_ctx.Posisition === 1)
                ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.listTransportationType, (data, index) => {
                    return (_openBlock(), _createBlock("div", {
                      class: ["flex justify-center p-1 cursor-pointer px-2", _ctx.classItemMenu(data)],
                      key: index,
                      style: {"border-radius":"6px"},
                      onClick: ($event: any) => (_ctx.changePositionTransType(data))
                    }, [
                      _createVNode("p", _hoisted_7, _toDisplayString(data.Nama), 1)
                    ], 10, ["onClick"]))
                  }), 128))
                : _createCommentVNode("", true)
            ]),
            (_ctx.Posisition === 1)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_InputSwitch, {
                    class: "switch-og red-not-checked",
                    modelValue: _ctx.isCheck,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.isCheck = $event))
                  }, null, 8, ["modelValue"]),
                  _hoisted_10
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.Posisition === 1)
            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                _hoisted_12,
                _createVNode("div", _hoisted_13, [
                  _createVNode(_component_InputNumber, {
                    id: "integeronly",
                    class: "input-primary rounded-lg input-bonus w-full",
                    modelValue: _ctx.bonus,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.bonus = $event)),
                    mode: "currency",
                    currency: "IDR",
                    locale: "id-ID"
                  }, null, 8, ["modelValue"]),
                  _hoisted_14
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_15, [
            _createVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode("span", _hoisted_18, [
                _hoisted_19,
                (_ctx.Posisition === 1)
                  ? (_openBlock(), _createBlock("p", _hoisted_20, _toDisplayString(_ctx.stringComission()), 1))
                  : (_openBlock(), _createBlock("p", _hoisted_21, _toDisplayString('Resi')))
              ])
            ])
          ]),
          _hoisted_22
        ])
      ]),
      _: 1
    })
  ]))
}